import { ComponentProps } from 'react';

import { Picture } from '@flipster/react/design-utils/picture';
import { Video } from '@flipster/react/design-utils/video';
import { Styles } from '@flipster/styled-system/css';

type VideoComponentProps = ComponentProps<typeof Video>;

interface ImgOrVideoProps {
  width?: number;
  video?: VideoComponentProps['src'];
  img?: VideoComponentProps['poster'];
  alt?: string | null;
  fetchPriority?: 'high' | 'low' | 'auto';
  loading?: 'lazy';
  css?: Styles;
}

export const ImgOrVideo = ({ width, img, alt, video, fetchPriority, loading, css: cssProps }: ImgOrVideoProps) => {
  if (video && img) return <Video poster={img} src={video} width={width} css={cssProps} />;

  if (img)
    return (
      <Picture
        src={img}
        alt={alt || 'flipster event image'}
        width={width}
        fetchPriority={fetchPriority}
        loading={loading}
        css={cssProps}
      />
    );

  return null;
};

export const contentfulImageUrl = (url: string) => {
  if (url.endsWith('.svg')) return url;
  if (url.endsWith('.lottie')) return url;
  return url + '?fm=webp&q=80';
};
